import type {
  IAvatarOptions,
  IAvatarElement,
  IAvatarAccessory
} from '../types';

import Store from '@/redux';
import { HAIR } from './hair';
import { FACE } from './face';
import { SHIRT } from './shirt';
import { PANTS } from './pants';

import { randomInt } from '@CS/utils/Number';
import { OPTIONS, getInt, getHex } from '@/utils/common';

export const PALETTES = ['#E97B98', '#9A488B', '#33BFD2', '#FFBC0D'];
export const ACCESSORIES_DEFAULT_COLOR = PALETTES[0];

export const SKIN = [
  '#f6e2c7',
  '#f3cfbd',
  '#f0cf98',
  '#dec19f',
  '#bc9371',
  '#966946',
  '#58473d'
];

export const COLOR = [
  '#FFBC0D',
  '#DB0007',
  '#264F36',
  '#9F4C8F',
  '#DE106B',
  '#46ABD2',
  '#E97733'
];

export const DefaultValues: IAvatarOptions = {
  [OPTIONS.age]: 1,
  [OPTIONS.name]: '',
  [OPTIONS.elements]: [
    {
      name: HAIR[0].name,
      color: 0x392827
    },
    {
      name: FACE[4].name,
      color: 0x392827
    },
    {
      name: 'Expression_Happy'
    },
    {
      name: SHIRT[4].name,
      color: 0xdb0007
    },
    {
      name: PANTS[16].name,
      color: 0x33bfd2
    }
  ],
  [OPTIONS.skinColor]: getInt(SKIN[0]),
  [OPTIONS.favoriteColor]: ''
};

export const getRandomValues = (): Partial<IAvatarOptions> => ({
  [OPTIONS.skinColor]: getInt(SKIN[randomInt(0, SKIN.length - 1)]),
  [OPTIONS.favoriteColor]: getHex(randomInt(0, 0xffffff)),
  [OPTIONS.age]: randomInt(1, 3),

  [OPTIONS.elements]: [
    getRandomElement(HAIR),
    getRandomElement(FACE),
    {
      name: 'Expression_Happy'
    },
    getRandomElement(SHIRT),
    getRandomElement(PANTS)
  ]
});

const getRandomElement = (list: IAvatarAccessory[]): IAvatarElement => {
  const { unlockedAvatarElements = [] } = Store.getState().user.family ?? {};

  list = list.filter(
    ({ id, available }) => available || unlockedAvatarElements.includes(id)
  );

  return {
    name: list[randomInt(0, list.length - 1)]?.name,
    color: randomInt(0, 0xffffff)
  };
};
